import React from 'react';
import { lookupDepartments, getMapsByDeptId, deleteMap } from '../../../../api';
import { connect } from 'react-redux';
import MapManagementPage from './MapManagementPage';
import DeleteRecord from '../../../UI/DeleteRecord';
import helper from '../../../../utils/helper';

const initPreDel = { open: false, mapName: '' };
const MapManagement = (props) => {
  const [departments, setDepartments] = React.useState([]);
  const [errors, setErrors] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [maps, setMaps] = React.useState([]);
  const [preDel, setPreDel] = React.useState(initPreDel);
  const { deptId } = helper.parseQueryString(props.location.search);
  const usersDept = JSON.parse(
    localStorage.getItem('userProfile'),
  ).departmentId;
  function getDept() {
    if (deptId || deptId === '0') {
      props.history.replace(`/configure/map-management?deptId=${deptId}`);
    } else
      return props.history.replace(
        `/configure/map-management?deptId=${usersDept}`,
      );
  }
  function getMaps() {
    if (deptId !== undefined) {
      getMapsByDeptId(deptId)
        .then((resp) => {
          const data = [];
          resp.map((r) =>
            data.push({
              id: r,
              name: r,
            }),
          );
          setMaps(data);
        })
        .catch((err) => setErrors(err));
    }
  }
  React.useEffect(() => {
    getDept();
    lookupDepartments()
      .then((resp) => setDepartments(resp.items))
      .catch((err) => setErrors(err))
      .finally(() => setLoading(false));
  }, []);
  React.useEffect(() => {
    getMaps();
  }, [deptId]);
  const columns = [{ dataField: 'name', text: 'Name', sort: true }];
  const defaultSorted = [
    {
      dataField: 'name',
      order: 'asc',
    },
  ];
  const ctxMenuOptions = [
    [
      {
        name: 'Edit map',
        action: (row, rowIndex) => {
          props.history.push(
            `/configure/map-management/edit?deptId=${deptId}&mapName=${row.name}`,
          );
        },
      },
      {
        name: 'Delete map',
        action: (row, rowIndex) => setPreDel({ open: true, mapName: row.name }),
      },
    ],
  ];
  function onDelete() {
    deleteMap(deptId, preDel.mapName)
      .then(() => setPreDel(initPreDel))
      .then(() => getMaps());
  }
  return (
    <>
      <DeleteRecord
        isOpen={preDel.open}
        title="Delete map"
        body="Are you sure you want to delete this map?"
        onCancel={() => setPreDel(initPreDel)}
        onConfirm={onDelete}
      />
      <MapManagementPage
        departments={departments}
        maps={maps}
        datagridProps={{
          keyField: 'name',
          data: maps,
          columns,
          defaultSorted,
          loading: false,
        }}
        ctxMenuOptions={ctxMenuOptions}
        deptId={deptId}
        onChangeDept={(deptId) =>
          props.history.push(`/configure/map-management?deptId=${deptId}`)
        }
      />
    </>
  );
};

export default connect(null, null)(MapManagement);
